import * as d3 from 'd3'
export default {

  methods: {
    /*
      app_Images
      app_SVG
      app_exLink
    */

    app_Images(selection, idx, data, d, server) {

      let items = selection
      let suffix = (data[d.code]) ? data[d.code] : ''
      let filePath = this[`HOST_${server}`] + d.url + d.file + suffix + '.' + d.ext

      items
      .append('image')
      .attr('id', `IMG_${idx}_${this.localId}`)
      .attr('xlink:href', filePath)
      .attr('transform', `translate(${d.x}, ${d.y})`)
      .attr('opacity', d.opacity ? d.opacity : 1)

      if(d.width) d3.select(`#IMG_${idx}_${this.localId}`).attr('width', d.width)
      if(d.height)d3.select(`#IMG_${idx}_${this.localId}`).attr('height', d.height)
      
      if(d.layer =='back') d3.select(`#IMG_${idx}_${this.localId}`).moveToBack()
    },



    app_SVG(selection, idx, data, d, server) {
    
      let items = selection
      let suffix = (data[d.code]) ? data[d.code] : ''
      let filePath = this[`HOST_${server}`] + d.url + d.file + suffix + '.' + d.ext
      
      this.loadSvg(
        items, {
        id: `SVG_${idx}_${this.localId}`, 
        url : filePath
      }).then(() => {
        d3.selectAll("text").style('font-family', 'roboto')
        d3.select(`#SVG_${idx}_${this.localId}`)
        .attr('transform', `translate(${d.x}, ${d.y}) scale(${d.scale})`)
        .attr('opacity', d.opacity)

        if(d.layer =='back') d3.select(`#SVG_${idx}_${this.localId}`).moveToBack()
      })
    },

    

    app_exLink(selection, idx, data, d, server) {

      let filePath = this[`HOST_${server}`] + d.icon.url + d.icon.file + '.' + d.icon.ext
      let items = selection
      .append('g')
      .attr('transform', `translate(${d.icon.x+.5}, ${d.icon.y+.5})`)
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(50).style('opacity', .4)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(50).style('opacity', 1)
      })
      .on('click', ()=> {
        window.location.href = window.location.origin + '/#/service/' + d.href
      })

      items
      .append('image')
      .attr('id', `LINK_${idx}_${this.localId}`)
      .attr('xlink:href', filePath)
      .attr('opacity', d.opacity ? d.opacity : 1)
      if(d.icon.width) d3.select(`#LINK_${idx}_${this.localId}`).attr('width', d.icon.width)
      if(d.icon.height)d3.select(`#LINK_${idx}_${this.localId}`).attr('height', d.icon.height)
      
      if(d.title) {
        items
        .append('text')
        .attr('x', d.title.x).attr('y', d.title.y + d.title.tSize*0.35)
        .attr('font-size', d.title.tSize).attr('fill', d.title.tColor)
        .attr('text-anchor', 'start')
        .text(d.title.name)
      }
    },
    
  }
}
